<template>
    <div ref="widget" class="cf-turnstile" data-sitekey="0x4AAAAAAEKeS2V6SFIvu6fX" data-action="turnstile-spin-v2"></div>
</template>

<script>
const SITE_KEY = '0x4AAAAAAEKeS2V6SFIvu6fX'
const ACTION = 'turnstile-spin-v2'
const SCRIPT_ID = 'cloudflare-turnstile-script'
const SCRIPT_URL = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'

let turnstileLoader = null

function loadTurnstile () {
    if (window.turnstile) {
        return Promise.resolve(window.turnstile)
    }

    if (turnstileLoader) {
        return turnstileLoader
    }

    turnstileLoader = new Promise((resolve, reject) => {
        const existingScript = document.getElementById(SCRIPT_ID)
        const script = existingScript || document.createElement('script')

        const loaded = () => {
            if (window.turnstile) {
                resolve(window.turnstile)
            } else {
                turnstileLoader = null
                reject(new Error('Cloudflare Turnstile did not initialize'))
            }
        }
        const failed = () => {
            turnstileLoader = null
            reject(new Error('Cloudflare Turnstile could not be loaded'))
        }

        script.addEventListener('load', loaded, { once: true })
        script.addEventListener('error', failed, { once: true })

        if (!existingScript) {
            script.id = SCRIPT_ID
            script.src = SCRIPT_URL
            script.async = true
            script.defer = true
            document.head.appendChild(script)
        }
    })

    return turnstileLoader
}

export default {
    props: {
        modelValue: {
            type: String,
            default: ''
        }
    },
    emits: ['update:modelValue', 'error'],
    data: function () {
        return {
            widget_id: null,
            unmounted: false
        }
    },
    mounted: async function () {
        try {
            const turnstile = await loadTurnstile()
            if (this.unmounted) {
                return
            }

            this.widget_id = turnstile.render(this.$refs.widget, {
                sitekey: SITE_KEY,
                action: ACTION,
                callback: token => this.$emit('update:modelValue', token),
                'expired-callback': () => this.$emit('update:modelValue', ''),
                'error-callback': () => {
                    this.$emit('update:modelValue', '')
                    this.$emit('error')
                }
            })
        } catch (error) {
            this.$emit('error', error)
        }
    },
    beforeUnmount: function () {
        this.unmounted = true
        if (this.widget_id !== null && window.turnstile) {
            window.turnstile.remove(this.widget_id)
        }
    },
    methods: {
        reset: function () {
            this.$emit('update:modelValue', '')
            if (this.widget_id !== null && window.turnstile) {
                window.turnstile.reset(this.widget_id)
            }
        }
    }
}
</script>
